export const zIndex = {
  header: 900,
  bottomNavigation: 900,
}
